<fury-page>
    <fury-title class="title">
        <h2>{{!articleId ? 'Add' : 'Update'}} Homeowner Article</h2>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="homeownerarticleform">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
                <h4>Article Info</h4>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px" style="justify-content: space-between;">
                  <div class="tirdwidth">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Select a category</mat-label>
                      <mat-select multiple formControlName="homeOwnerCategoryIds">
                        <mat-option [value]="owner?.homeOwnerCategoryId" *ngFor="let owner of homeownerCategorylist">
                          {{owner?.title}}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="homeownerarticleform.controls['homeOwnerCategoryIds'].touched && homeownerarticleform.controls['homeOwnerCategoryIds'].hasError('required')">
                        This is a required field.
                      </mat-error>
                    </mat-form-field>
                    
                  </div>

                  <div class="tirdwidth">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Select Author</mat-label>
                      <mat-select formControlName="authorId">
                        <mat-option [value]="owner?.authorId" *ngFor="let owner of authorList">
                          {{owner?.fullName}}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="homeownerarticleform.controls['authorId'].touched && homeownerarticleform.controls['authorId'].hasError('required')">
                        This is a required field.
                      </mat-error>
                    </mat-form-field>
                  </div>
      
                  <div class="tirdwidth">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Publish date</mat-label>
                      <input matInput formControlName="publishDate" [matDatepicker]="picker" [max]="todayDate" readonly>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                      <mat-error
                        *ngIf="homeownerarticleform.controls['publishDate'].touched && homeownerarticleform.controls['publishDate'].hasError('required')">
                        This is a required field.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <mat-form-field fxFlex="auto" appearance="outline">
                  <mat-label>Meta Title</mat-label>
                  <input matInput placeholder="Meta Title" formControlName="metaTitle" (keyup)="apiService.restrictChar($event, 65)">
                  <mat-hint>Meta Title Character Count: {{(65 - homeownerarticleform.controls['metaTitle'].value.length) > 0 ? (65 - homeownerarticleform.controls['metaTitle'].value.length) : 0}}</mat-hint>
                  <mat-error
                    *ngIf="homeownerarticleform.controls['metaTitle'].touched && homeownerarticleform.controls['metaTitle'].hasError('required')">
                    This is a required field.
                  </mat-error>
                </mat-form-field>
                
                <mat-form-field fxFlex="auto" appearance="outline">
                  <mat-label>Meta Description</mat-label>
                  <textarea matInput placeholder="Meta Description" formControlName="metaDescription" (keyup)="apiService.restrictChar($event, 155)">
                  </textarea>
                  <mat-hint>
                    Meta Description Character Count: {{(155 - homeownerarticleform.controls['metaDescription'].value.length) > 0 ? (155 - homeownerarticleform.controls['metaDescription'].value.length) : 0}}
                  </mat-hint>
                  <mat-error
                    *ngIf="homeownerarticleform.controls['metaDescription'].touched && homeownerarticleform.controls['metaDescription'].hasError('required')">
                    This is a required field.
                  </mat-error>
                </mat-form-field>
              
            
                  <fxLayout fxLayout="column"  fxLayoutGap.gt-sm="24px"
                  style="margin-bottom: 20px;align-items: baseline; width: 100% !important;">
                  <h2 style="color: #2f4a40;">Upload preview image</h2>
                  <div class="flex">
                    <div class="innerdiv">
                      <div class="uploadsec" style="margin-right: 20px">
                        <div class="imgsec">
                          <img
                            [src]="imagestoupload ? imagestoupload : '../../../../../assets/img/no_thumbnail.jpg'"
                            alt="">
                        </div>
                        <div class="uploadbtnsec">
                          <input type="file" #image_one (change)="onImageUpload($event)"
                            accept=".png, .jpg, .jpeg" style="display:none">
                          <button class="uploadfilebtn" mat-raised-button (click)="image_one.click()">Upload
                            image</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  </fxLayout>
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Alt Text</mat-label>
                    <input matInput placeholder="Alt Text" formControlName="bannerImageAlternateText">
                    <mat-error
                      *ngIf="homeownerarticleform.controls['bannerImageAlternateText'].touched && homeownerarticleform.controls['bannerImageAlternateText'].hasError('required')">
                      This is a required field.</mat-error>
                  </mat-form-field>
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Title</mat-label>
                    <input matInput placeholder="Title" formControlName="title">
                    <mat-error
                      *ngIf="homeownerarticleform.controls['title'].touched && homeownerarticleform.controls['title'].hasError('required')">
                      This is a required field.</mat-error>
                  </mat-form-field>
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>URL Slug</mat-label>
                    <input matInput [placeholder]="'Ex. '+homeownerarticleform.value.title?.split(' ')?.join('-')" formControlName="slug">
                    <mat-error
                      *ngIf="homeownerarticleform.controls['slug'].touched && homeownerarticleform.controls['slug'].hasError('required')">
                      This is a required field.</mat-error>
                  </mat-form-field>
                  <fxLayout fxLayout="column" fxLayoutGap.gt-sm="24px"
                          style="margin-bottom: 20px; width: 100% !important;">
                        
                          <mat-label>Description</mat-label>
                          <ckeditor [config]="editorConfig" formControlName="description" debounce="500"></ckeditor>
                          <mat-error
                            *ngIf="homeownerarticleform.controls['description'].touched && homeownerarticleform.controls['description'].hasError('required')">
                            This is a required field.</mat-error>
                  </fxLayout>

                  <div>
                    <span>
                      Website Status 
                      <mat-slide-toggle formControlName="websiteStatus"></mat-slide-toggle>
                    </span>
                  </div>
  
            </div>
            
            <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
              <button mat-button type="button" class="sub-button" (click)="submit()">{{!articleId ? 'Add' : 'Update'}}</button>
              <button class="can-button" (click)="this.location.back()" mat-button>Cancel</button>
            </div>
  
            
            
          </form>
    </div>
  </div>

